module.exports = __webpack_public_path__ + "img/point_detail_bg.1dd4f611.png";